/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, put, takeLatest } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { IDocumentDownload, IDownloadDocumentRequest } from 'app/interfaces/document-download/document-download.interface';
import {
	getMarketplaceListAction,
	IMarketplaceListRequest,
	IMarketplaceListResponse,
	marketplaceDownloadFactsheetAction,
	marketplaceSetFactsheetAction,
	resetMarketplaceFactsheetAction,
	resetMarketplaceListAction,
	setMarketplaceListAction,
	getTNCPrivacyPolicy,
	setTNCPrivacyPolicy,
	ITncPrivacyPolicyRequest,
	IBulkMarketplaceListResponse,
	IBulkMarketplaceListRequest,
	setBulkMarketplaceList,
	getBulkMarketplaceList,
	setBulkSummaryList,
	IBulkSummaryListRequest,
	IBulkSummaryListResponse,
	getBulkSummaryList,
	setBulkLoanNumberAction,
	getBulkLoanNumberAction
} from "../actions/MarketplaceListAction";
import apiRequest from '../api/api.request';
import endpoints from '../../../constants/endpoints';
import { ApiRequestConfig } from '../../interfaces/api-request/api.interface';
// import environment from '../../../environments/environment';
import { setFactsheetAction } from '../actions/PortofolioAction';
import { IBulkLoanNumberRequest, IBulkLoanNumberResponse } from '../actions/FundingAction';

function* fetchMarketplaceList({
	payload,
}: {
	payload: IMarketplaceListRequest
}): Generator {
	// const auth = `${environment.authUsername}:${environment.authPassword}`;
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
	const config: ApiRequestConfig = {
		path: endpoints.api.MARKETPLACE_LIST,
		method: 'GET',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
		},
		query: payload,
		body: null,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const { data, pagination } = res as any;
		const result = {
			marketplaceList: data,
			pagination
		};
		yield put(setMarketplaceListAction(result));
		return payload;
	} catch (err) {
		return err;
	}
}

function setMarketplaceListSaga({
	payload,
}: {
	payload: IMarketplaceListResponse;
}): IMarketplaceListResponse | unknown {
	try {
		return payload;
	} catch (err) {
		return err;
	}
}

function setFactsheetSaga({
	payload,
}: {
	payload: IDocumentDownload;
}): IDocumentDownload {
	try {
		return payload;
	} catch (err) {
		return payload;
	}
}

function* downloadDocumentSaga({
	payload,
}: {
	payload: IDownloadDocumentRequest
}): Generator {
	// const auth = `${environment.authUsername}:${environment.authPassword}`;
	const userData = localStorage.getItem('user');
	let userToken = "";
	if (userData) {
		const resp = JSON.parse(userData);
		userToken = resp.token;
	}
	const config: ApiRequestConfig = {
		path: endpoints.api.DOWNLOAD_DOCUMENT,
		method: 'POST',
		headers: {
			Authorization: `Bearer ${userToken}`,
		},
		query: null,
		body: payload,
		timeout: 0,
		responseType: 'arraybuffer', // ini adalah kunci
	};
	try {
		const resp = yield call(apiRequest, config);

		let type = 'image/*';
		if (payload.document_url.includes('.pdf')) {
			type = 'application/pdf';
		}

		const blobResult = new Blob([new Uint8Array(resp as any)], { type });

		yield put(marketplaceSetFactsheetAction({ base64Image: blobResult }));
	} catch (err) {
		// return payload;
	}
}

function resetFactsheetSaga({
	payload,
}: {
	payload;
}): IDocumentDownload {
	try {
		return payload;
	} catch (err) {
		return payload;
	}
}

function resetMarketplaceListSaga({
	payload,
}: {
	payload;
}): IDocumentDownload {
	try {
		return payload;
	} catch (err) {
		return payload;
	}
}

function* fetchTNCPrivacyPolicy({
	payload,
}: {
	payload: ITncPrivacyPolicyRequest
}): Generator {
	// const auth = `${environment.authUsername}:${environment.authPassword}`;
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
	const config: ApiRequestConfig = {
		path: endpoints.api.TNC_LIST,
		method: 'GET',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
			Platform: `WEB`,
			Language: `ID`,
		},
		query: payload,
		body: null,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
        const { data } = res as any;
		yield put(setTNCPrivacyPolicy(data));
		return payload;
	} catch (err) {
		return err;
	}
}

function* fetchBulkMarketplaceList({
	payload,
}: {
	payload: IBulkMarketplaceListRequest
}): Generator {
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
	const config: ApiRequestConfig = {
		path: endpoints.api.BULK_MARKET_LIST,
		method: 'GET',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
		},
		query: payload,
		body: null,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const {	data, pagination } = res as any;
		const result = {
			bulkList: data.bulkList,
			isBulkFunding: data.isBulkFunding,
			pagination
		};
		yield put(setBulkMarketplaceList(result));
		return payload;
	} catch (err) {
		return err;
	}
}

function setBulkMarketplaceListSaga({
	payload,
}: {
	payload: IBulkMarketplaceListResponse;
}): IBulkMarketplaceListResponse | unknown {
	try {
		return payload;
	} catch (err) {
		return err;
	}
}

function* fetchBulkSummaryList({
	payload,
}: {
	payload: IBulkSummaryListRequest
}): Generator {
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
	const config: ApiRequestConfig = {
		path: endpoints.api.BULK_SUMMARY_LIST,
		method: 'GET',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
			'X-REQUEST-ID': uuidv4(),
			platform: "Web"
		},
		query: payload,
		body: null,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const {	data, pagination } = res as any;
		const result = {
			bulkSummaryList: data,
			pagination
		};
		yield put(setBulkSummaryList(result));
		return payload;
	} catch (err) {
		return err;
	}
}

function setBulkSummaryListSaga({
	payload,
}: {
	payload: IBulkSummaryListResponse;
}): IBulkSummaryListResponse | unknown {
	try {
		return payload;
	} catch (err) {
		return err;
	}
}

function* fetchBulkLoanNumber({
	payload,
}: {
	payload: IBulkLoanNumberRequest
}): Generator {
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
	const config: ApiRequestConfig = {
		path: endpoints.api.BULK_LOAN_NUMBER,
		method: 'GET',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
			'X-REQUEST-ID': uuidv4(),
			platform: "Web",
		},
		query: payload,
		body: null,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const {	data } = res as any;
		yield put(setBulkLoanNumberAction(data));
		return payload;
	} catch (err) {
		return err;
	}
}

function setBulkLoanNumberSaga({
	payload,
}: {
	payload: IBulkLoanNumberResponse[];
}): IBulkLoanNumberResponse[] | unknown {
	try {
		return payload;
	} catch (err) {
		return err;
	}
}

export default function* marketplaceListSaga(): Generator {
	yield takeLatest(getMarketplaceListAction, fetchMarketplaceList);
	yield takeLatest(setMarketplaceListAction, setMarketplaceListSaga);
	yield takeLatest(resetMarketplaceListAction, resetMarketplaceListSaga);
	yield takeLatest(marketplaceDownloadFactsheetAction, downloadDocumentSaga);
	yield takeLatest(setFactsheetAction, setFactsheetSaga);
	yield takeLatest(resetMarketplaceFactsheetAction, resetFactsheetSaga);
	yield takeLatest(getTNCPrivacyPolicy, fetchTNCPrivacyPolicy);
	yield takeLatest(getBulkMarketplaceList, fetchBulkMarketplaceList);
	yield takeLatest(setBulkMarketplaceList, setBulkMarketplaceListSaga);
	yield takeLatest(getBulkSummaryList, fetchBulkSummaryList);
	yield takeLatest(setBulkSummaryList, setBulkSummaryListSaga);
	yield takeLatest(getBulkLoanNumberAction, fetchBulkLoanNumber);
	yield takeLatest(setBulkLoanNumberAction, setBulkLoanNumberSaga);
}
